import { render, staticRenderFns } from "./userDetail.vue?vue&type=template&id=8c3b9428&scoped=true&"
import script from "./userDetail.vue?vue&type=script&lang=js&"
export * from "./userDetail.vue?vue&type=script&lang=js&"
import style0 from "./userDetail.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./userDetail.vue?vue&type=style&index=1&id=8c3b9428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c3b9428",
  null
  
)

export default component.exports